import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IUserGroupsService } from "services/UserGroupsService";
import { IntSelectModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  UserGroupSelectModels: new Array<IntSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const userGroupSelectSlice = createSlice({
  name: "userGroupSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserGroups.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getUserGroups.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getUserGroups.fulfilled, (state, action) => {
        state.UserGroupSelectModels = action.payload.map(
          (x) => new IntSelectModel({ value: x.userGroupID, label: x.groupName })
        );
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getUserGroups = createAsyncThunk("UserGroups/GetUserGroups", async () => {
  const userGroupsService = container.get<IUserGroupsService>(SERVICE_TYPES.UserGroupsService);
  return await userGroupsService.getAllUserGroups();
});

export const selectUserGroupSelectModels = (state: RootState) => state.userGroupsSelect.UserGroupSelectModels;
export const selectLoading = (state: RootState) => state.userGroupsSelect.Loading;
export const selectLastUpdateTime = (state: RootState) => state.userGroupsSelect.LastUpdateTime;

export default userGroupSelectSlice.reducer;
